import apiClient from './api';

async function createPayment() {
  try {
    const response = await apiClient.post('/payments/create'); // your backend
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message || 'Payment failed' };
  }
}



async function freeCheckout() {
  try {
    const response = await apiClient.post('free-checkout'); // your backend
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message || 'Payment failed' };
  }
}

export { createPayment, freeCheckout };
